module.exports = "#version 100\r\nprecision highp float;\r\n\r\nuniform float u_targetWidth;\r\n\r\nattribute vec3 a_position;\r\n\r\nvarying vec2 blurTextureCoords[11];\r\n\r\nvoid main() {\r\n    gl_Position = vec4(a_position, 1.0);\r\n\r\n    vec2 centerTexCoords = a_position.xy * 0.5 + 0.5;\r\n\r\n    float pixelSize = 1.0 / u_targetWidth;\r\n\r\n    for(int i = -5; i <= 5; i++){\r\n      blurTextureCoords[i + 5] = centerTexCoords + vec2(pixelSize * float(i), 0.0);\r\n    }\r\n\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/horizontalBlurRTT.vert.glsl
// module id = 10
// module chunks = 0